<section class="scenarios-grid">
  @if (campaignId) {
    @for (s of scenarios; track s.id) {
      <article class="scenario-card">
        <header class="scenario__hdr">
          <div class="scenario__label" [innerHTML]="s.label"></div>
          <button
            type="button"
            class="clear-filters-btn"
            (click)="removeScenario.emit(s.id)"
            [attr.aria-label]="scenarioContent()?.cleanFiltersButton">
            <span class="clear-filters-btn__label">{{ scenarioContent()?.cleanFiltersButton }}</span>
            <span class="clear-filters-btn__icon" aria-hidden="true">
                <app-svg-icon src="assets/icons-reports/cerrarFiltros.svg"></app-svg-icon>
            </span>
          </button>
        </header>
        <div class="scenario__content">
          @switch (s.analysisMode) {
            @case ('final-assessments') {
              <app-final-assessments-breakdown
                [campaignId]="campaignId"
                [guideId]="guideId"
                [activeFacets]="s.facets"
                [filters]="s.filters"
                [showEmpty]="true"
                [showLoading]="true">
              </app-final-assessments-breakdown>
            }
            @case ('category-scores') {
              <app-category-scores-breakdown
                [campaignId]="campaignId"
                [guideId]="guideId"
                [activeFacets]="s.facets"
                [filters]="s.filters"
                [showEmpty]="true"
                [showLoading]="true">
              </app-category-scores-breakdown>
            }
            @case ('domain-scores') {
              <app-domain-scores-breakdown
                [campaignId]="campaignId"
                [guideId]="guideId"
                [activeFacets]="s.facets"
                [filters]="s.filters"
                [showEmpty]="true"
                [showLoading]="true">
              </app-domain-scores-breakdown>
            }
          }
        </div>
      </article>
    }
  } @else {
    <p class="empty-state">{{ scenarioContent()?.selectCampaignLabel }}</p>
  }
</section>
